export const ORG_EN = {
  name: "Head Office",
  tel: '02-254-4900 - 06',
  email: "info@takecarebeauty.com",
  address: "18/1 sukhumvit 19 yaek 2 road, klongtoei-nue sub-district, wattana district, bangkok 10110",
}
export const ORG_TH = {
  name: "สำนักงานใหญ่",
  tel: '02-254-4900 - 06',
  email: "info@takecarebeauty.com",
  address: "18 ซอยสุขุมวิท 19 แยก 2 แขวงคลองเตยเหนือ เขตวัฒนา กทม 10110",
}


export const BRANCH: any[] =
[
    {
        "id": "1",
        "nameTH": "สุขุมวิท 19",
        "nameEN": "Sukhumvit 19",
        "picture": "assets/images/branch/s_19.jpg",
        "addressTH": "19/31 ซอยสุขุมวิท 19 แขวงคลองตันเหนือ แขวงคลองเตยเหนือ เขตวัฒนา กรุงเทพมหานคร 10110",
        "addressEN": "19/31 Sukhumvit 19, Khlong Toei Nuea, Watthana, Bangkok 10110",
        "latitude": "13.7393418",
        "longitude": "100.5599726",
        "tel": "(66) 0-2254-4780 , (66) 0-2651-1411",
        "branchServiceTH": "ผม เล็บ ขนตา แว็กซ์ขน สปาและนวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "2",
        "nameTH": "ซาลอน ดิ บิ้วติ้ ( เทอร์มินัล 21 ขั้น1 )",
        "nameEN": "Salon De Beauty ( Terminal 21 1st Fl. )",
        "picture": "assets/images/branch/the_beauty.jpg",
        "addressTH": "Terminal 21 ชั้น1 ห้อง 1047B ซอยสุขุมวิท 19  แขวงคลองเตยเหนือ เขตวัฒนา กทม. 10110",
        "addressEN": "Terminal 21, 1st Floor, Room 1047B Sukhumvit 19, Klongtoei North, Wattana, Bangkok, 10110",
        "latitude": "13.7377007",
        "longitude": "100.5601033",
        "tel": "(66) 0-2108-3827 , (66) 0-2002-1989",
        "branchServiceTH": "ขนตา แว็กซ์ขน สปา สัก",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "3",
        "nameTH": "เทอมินอล 21 ชั้น 1",
        "nameEN": "Terminal 21 1st Fl.",
        "picture": "assets/images/branch/t21.jpg",
        "addressTH": "Terminal 21 ชั้น1 ห้อง 1045 ซอยสุขุมวิท 19  แขวงคลองเตยเหนือ เขตวัฒนา กทม. 10110",
        "addressEN": "Terminal 21, 1st Floor, Room 1045, Sukhumvit 19, Klongtoei North, Wattana, Bangkok, 10110",
        "latitude": "13.7373571",
        "longitude": "100.5606032",
        "tel": "(66) 0-2108-0753-4",
        "branchServiceTH": "ผม เล็บ",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "4",
        "nameTH": "เอ็มควอเทียร์ ชั้น 2",
        "nameEN": "The Emquartier 2nd Fl.",
        "picture": "assets/images/branch/eq.jpg",
        "addressTH": "ศูนย์การค้าดิเอ็มควอเทียร์  ตึกวอเตอร์ฟอลล์(Building C) ชั้น 2",
        "addressEN": "The Emquartier 2nd Fl",
        "latitude": "13.7330322",
        "longitude": "100.5698327",
        "tel": "(66) 0-258-0284 , (66) 0-2258-0285",
        "branchServiceTH": "",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "5",
        "nameTH": "สุขุมวิท 35",
        "nameEN": "Sukhumvit 35 Lady",
        "picture": "assets/images/branch/s_35.jpg",
        "addressTH": "599/5-6 ซอยสุขุมวิท 35 แขวงคลองตันเหนือ แขวง คลองตันเหนือ เขต วัฒนา กรุงเทพมหานคร 10110",
        "addressEN": "599/5-6 Sukhumvit 35, Khlong Tan Nuea, Watthana, Bangkok 10110",
        "latitude": "13.7314161",
        "longitude": "100.5685821",
        "tel": "(66) 0-2258-7543-4",
        "branchServiceTH": "ผม เล็บ ขนตา แว็กซ์ขน สัก สปาและนวด",
        "branchServiceEN": "Hair ,",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "6",
        "nameTH": "วันแมนคลับ สุขุมวิท 35",
        "nameEN": "One Man Club Sukhumvit 35",
        "picture": "assets/images/branch/m.JPG",
        "addressTH": "599/7 ซอย Sukumvit 35 แขวง คลองตันเหนือ เขต วัฒนา กทม 1011",
        "addressEN": "599/7 Sukhumvit 35, Khlong Tan Nuea, Watthana, Bangkok 10110",
        "latitude": "13.7314692",
        "longitude": "100.5686338",
        "tel": "(66) 0-2034-3267 , (66) 0-2034-3268",
        "branchServiceTH": "ผม เล็บ แว็กซ์ขน สปาและนวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "7",
        "nameTH": "สยามพาราก้อน ชั้น M",
        "nameEN": "Siam Paragon M Fl.",
        "picture": "assets/images/branch/siam.JPG",
        "addressTH": "สยามพารากอน 991/1 ชั้น M ( Beauty Hall ) ถ. พระราม 1 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330",
        "addressEN": "Siam Paragon, M Floor ( Beauty Hall ), Pathum Wan, Pathum Wan, Bangkok 10330",
        "latitude": "13.7468291",
        "longitude": "100.5350307",
        "tel": "(66) 0-2610-7771",
        "branchServiceTH": "เล็บ ขนตา แว็กซ์ขน นวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "8",
        "nameTH": "สีลม คอมเพ็กซ์ ชั้น 3",
        "nameEN": "Silom Complex 3rd Fl.",
        "picture": "assets/images/branch/selom.JPG",
        "addressTH": "191 อาคารสีลมคอมเพล็กซ์ ชั้น3 ห้อง312 ถ.สีลม แขวงบางรัก เขตบางรัก กทม. 10500",
        "addressEN": "191 อาคารสีลมคอมเพล็กซ์ ชั้น3 ห้อง312 ถ.สีลม แขวงบางรัก เขตบางรัก กทม. 10500",
        "latitude": "13.7284497",
        "longitude": "100.5346274",
        "tel": "(66) 0-2231-3875-6, (66) 0-2231-3391-3",
        "branchServiceTH": "เล็บ ขนตา แว็กซ์ขน สปาและนวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "9",
        "nameTH": "มาร์เก็ตเพลส ชั้น 2",
        "nameEN": "Market Place",
        "picture": "assets/images/branch/mkp.jpg",
        "addressTH": "มาร์เก็ตเพลส ชั้น 2 ทองหล่อ ซอย 4-6 กรุงเทพฯ  10110",
        "addressEN": "Market Place Sukhumvit 55 (ThongLor Soi 4-6)",
        "latitude": "13.7287503",
        "longitude": "100.5815878",
        "tel": "(66) 0-2392-9690",
        "branchServiceTH": "เล็บ แว็กซ์ขน",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "10",
        "nameTH": "เจ-อเวนิว ชั้น 3 ทองหล่อ ซอย 15",
        "nameEN": "J-Avenue 3rd Fl. Sukhumvit 55 (ThongLor Soi 15)",
        "picture": "assets/images/branch/j.jpg",
        "addressTH": "323/1 อาคารเจอเวนิว (ชั้น 3) สุขุมวิท 55 ทองหล่อ 15 คลองตันเหนือ เขตวัฒนา กรุงเทพ 10110",
        "addressEN": "323/1 J-Avenue 3rd Fl. Sukhumvit 55 (ThongLor Soi 15) Khlong Toei Nuea, Watthana, Bangkok 10110",
        "latitude": "13.7344825",
        "longitude": "100.5823244",
        "tel": "(66) 0-2712-6750",
        "branchServiceTH": "เล็บ ขนตา แว็กซ์ขน นวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "11",
        "nameTH": "แฟชั่น ไอร์แลนด์ ชั้น 2",
        "nameEN": "Fashion Island 2rd Fl.",
        "picture": "assets/images/branch/fasion.jpg",
        "addressTH": "ศูนย์การค้าแฟชั่นไอส์แลนด์ ชั้น2 เสาที่ 230 587,589,589/7-9 ถนนรามอินทรา แขวงคันนายาว เขตคันนายาว กทม 10230",
        "addressEN": "Fashion Island 2rd Fl. ",
        "latitude": "13.8261797",
        "longitude": "100.6785872",
        "tel": "(66) 0-2947-5591 , (66) 0-2947-5592",
        "branchServiceTH": "เล็บ , แว็กซ์ขน",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },      
      {
        "id": "12",
        "nameTH": "เซ็นจูรี่ ชั้น 3",
        "nameEN": "Century 3rd Fl.",
        "picture": "assets/images/branch/cjr.jpg",
        "addressTH": "ถนนสุขุมวิท แขวงพระโขนงเหนือ เขตพระโขนง กรุงเทพฯ 10250 (BTS อ่อนนุช ทางออก 3)",
        "addressEN": "ถนนสุขุมวิท แขวงพระโขนงเหนือ เขตพระโขนง กรุงเทพฯ 10250 (BTS อ่อนนุช ทางออก 3)",
        "latitude": "13.7057432",
        "longitude": "100.6015263",
        "tel": "(66) 0-2064-0494 , (66) 0-2064-0495",
        "branchServiceTH": "",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "13",
        "nameTH": "สุขุมวิท 33",
        "nameEN": "Sukhumvit 33",
        "picture": "assets/images/branch/s_33.jpg",
        "addressTH": "ซอยสุขุมวิท 33 แขวงคลองตันเหนือ แขวง คลองเตยเหนือ เขต วัฒนา กรุงเทพมหานคร 10110",
        "addressEN": "Sukhumvit 33, Khlong Tan Nuea, Watthana, Bangkok 10110",
        "latitude": "13.7057432",
        "longitude": "100.6015263",
        "tel": "(66) 0-2662-0853 , (66) 0-2662-0805",
        "branchServiceTH": "",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      },
      {
        "id": "14",
        "nameTH": "นิว เจ-อเวนิว ชั้น 3 ทองหล่อ ซอย 15",
        "nameEN": "New J-Avenue 3rd Fl. Sukhumvit 55 (ThongLor Soi 15)",
        "picture": "assets/images/branch/newj.jpg",
        "addressTH": "เจ-อเวนิว ชั้น 3 ทองหล่อ ซอย 15 กรุงเทพฯ 10110",
        "addressEN": "J-Avenue 3rd Fl. Sukhumvit 55 (ThongLor Soi 15) Bangkok 10110",
        "latitude": "13.7344825",
        "longitude": "100.5823244",
        "tel": "02-0885294 , 02-0885295",
        "branchServiceTH": "เล็บ ขนตา แว็กซ์ขน นวด",
        "branchServiceEN": "",
        "openingHoursTH": "10.00 น. - 21.00 น.",
        "openingHoursEN": "10.00 - 21.00"
      }
];


// WEBPACK FOOTER //
// ./src/app/mokup/branch.ts